module.exports = __webpack_public_path__ + "static/portfolio-2-ae951cd6f1e01c3f80f0224511c0ec4f.jpg";